import * as Constants from '../constants/index';

export function getItemDetailsForAnalytics(product, index) {
    return ({
        item_name: product.name,
        item_id: product.productId,
        item_type: Constants.ITEM_TYPE_OTC,
        item_rank: index,
        item_price: product.mrpDecimal,
        item_discount_amount: product.salePriceDecimal,
        item_discount_percentage: product.discountPercent,
        item_image_url: product.images.length && product.images[0],
        item_ucode: product.ucode,
        item_recommendation_incentive: product.recommendationIncentive,
        metric_str_1: 'itemReType',
        val_str_1: product.itemReType
    })
}

export function getElementDetailsForAnalytics() {
    return ({
        element_name: Constants.RECOMMENDATION_SOURCE,
        element_type: Constants.ELEMENT_TYPE_RECOMMENDATION,
        element_scroll_type: Constants.ELEMENT_SCROLL_TYPE_HORIZONTAL,
    })
}

export function getCommonPayloadForAnalytics(customer, cart, agent) {
    return ({
        has_placed_order: customer.customerDetails.data.profile.hasPlacedOrder,
        has_delivered_order: customer.customerDetails.data.profile.hasDeliveredOrder,
        is_chronic: customer.customerDetails.data.profile.chronic,
        has_diag_fulfilled_order: customer.customerDetails.data.profile.hasCompletedDiagnosticOrder,
        has_placed_diag_order: customer.customerDetails.data.profile.hasPlacedDiagnosticOrder,
        is_pincode_courier: customer.cityAttributes.isCourierCity > 0,
        selected_city: customer.cityAttributes.name,
        selected_pincode: customer.selectedPincode,
        session_id: customer.sessionId,
        email: customer.customerDetails.data.profile.profileEmail,
        is_cart_empty: !(cart.data.itemsCount > 0),
        customer_id: customer.customerDetails.data.profile.id,
        agent_id: agent.data.userId,
    })
}